import React from 'react';
import { InputTotalValueStyle } from './style';

export default function InputTotalValue({ setTotalValue, value, disabled }) {
  return (
    <InputTotalValueStyle>
      <label>Valor Total do mês</label>
      <input
        type="text"
        onChange={(e) => {
          let value = e.target.value;
          value = value.replace('.', '');
          value = value.replace(',', '.');
          setTotalValue(value);
        }}
        value={value}
        disabled={disabled}
        placeholder="Exemplo: 1.000,00 ou 1000,00 ou 1000"
      />
    </InputTotalValueStyle>
  );
}
